import { Button, ButtonSizesEnum, ButtonThemesEnum } from '@propertyfinder/button';
import { IconSpriteEnvelopeFilled, IconSpritePhoneFilled } from '@propertyfinder/icons';
import { FunctionComponent, h } from 'preact';
import { useState } from 'preact/hooks';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { preactLifecycleComponent } from 'common/module/preact/lifecycle-component';
import { ProgressiveImageComponent } from 'common/module/progressive-image/component';
import { TagNewComponent } from 'common/module/tag-new/component';
import { TagNewTypeEnum } from 'common/module/tag-new/type.enum';

import { AgentCard1TemplatePropsInterface } from './template-props.interface';

/**
 * Used in the broker detail agent list tab
 *
 * TODO-FE[WEB-1602]: Ensure this view implements common AgentCardTemplatePropsInterface
 */
const Markup: FunctionComponent<AgentCard1TemplatePropsInterface> = (props) => {
  const [showPhoneNumber, setShowPhoneNumber] = useState(false);

  return (
    <article className='agent-card' onClick={(e) => props.onClick(e, props.agent)}>
      <a className='agent-card__link' href={props.agent.links.profile} />
      <div className='agent-card__body'>
        <ProgressiveImageComponent
          src={props.agent.links.image_desktop}
          classname='agent-card__img'
          alt={props.agent.name}
          title={props.agent.name}
          loadedClass='agent-card__img--loaded'
          placeholder={__('assets/common/agent-tile-placeholder.jpg')}
          preloader={__('assets/common/image-loader.svg')}
        />
        <div className='agent-card__content'>
          <div className='agent-card__main-info'>
            <div className='agent-card__credentials'>
              <h5>{props.agent.name}</h5>
              <p className='aget-card__position'>{props.agent.position}</p>
              {props.agent.is_trusted && (
                <TagNewComponent className='agent-card__tag' type={TagNewTypeEnum.SUPER_AGENT} />
              )}
            </div>
            <ProgressiveImageComponent
              classname='agent-card__broker-img'
              alt={props.agent.broker.name}
              src={props.agent.broker.links.logo_178_98}
              placeholder={__('assets/common/broker-tile-placeholder.jpg')}
            />
          </div>
          <div className='agent-card__secondary-info'>
            <div className='agent-card__spec-titles'>
              <p className='agent-card__spec-item'>{i18nTranslate('Company')}</p>
              <p className='agent-card__spec-item'>{i18nTranslate('Nationality')}</p>
              <p className='agent-card__spec-item'>{i18nTranslate('Languages')}</p>
            </div>
            <div className='agent-card__spec-values'>
              <p className='agent-card__spec-item'>{props.agent.broker.name}</p>
              <p className='agent-card__spec-item'>{props.agent.country_name}</p>
              <p className='agent-card__spec-item'>
                {props.agent.languages.map((language) => language.name).join(', ')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <footer className='agent-card__footer'>
        <div className='card-footer__buttons'>
          <Button
            className='card-footer__button'
            data-qs='cta'
            onClick={(e: MouseEvent) => {
              e.preventDefault();
              setShowPhoneNumber(true);
              props.onClickCall(e, props.agent);
            }}
            size={ButtonSizesEnum.SMALL}
            theme={ButtonThemesEnum.SECONDARY}
          >
            <IconSpritePhoneFilled className='card-footer__button-icon' />
            {showPhoneNumber ? props.agent.public_phone : i18nTranslate('Call')}
          </Button>
          <Button
            className='card-footer__button'
            data-qs='cta'
            onClick={(e: MouseEvent) => {
              props.onClickEmail(e, props.agent);
            }}
            size={ButtonSizesEnum.SMALL}
            theme={ButtonThemesEnum.SECONDARY}
          >
            <IconSpriteEnvelopeFilled className='card-footer__button-icon' />
            <span>{i18nTranslate('cta:email-desktop')}</span>
          </Button>
        </div>
      </footer>
    </article>
  );
};

export const AgentCard1Template = preactLifecycleComponent(Markup);
